__turbopack_context__.v({
  "className": "sourceserif_cad6e30c-module__sBcmVW__className",
  "variable": "sourceserif_cad6e30c-module__sBcmVW__variable",
});
